// extracted by mini-css-extract-plugin
module.exports = {"root":"banner-icon_root__aDCI9"};